import {
  Button,
  Stack,
  Grid,
  Group,
  Box,
  Title,
  Text,
  Textarea,
  Select,
  useMantineTheme,
} from "@mantine/core";
import { formatString, globalTableReset } from "../helpers/GetAQuoteHelpers";
import Line from "./Line";
import { MarkerSolidIcon } from ".././icons";
import StopSelector from "./StopSelector";
import { DatePickerInput } from "@mantine/dates";
import { formatDateToYMD } from "../helpers/GetAQuoteHelpers";
import TimeDurationPicker from "./TimeDurationPicker";
import AddressInput from "./AddressInput";
import { Calendar } from "../icons";

export default function ItineraryBuilder({
  formData,
  updateFormField,
  updateLocation,
}) {
  return (
    <Stack gap="lg">
      <style>{globalTableReset}</style>
      <Title>Itinerary Information</Title>
      <Grid>
        <DatePickerInput
          w={"100%"}
          p={8}
          withAsterisk
          label="Date of travel"
          weekendDays={[]}
          firstDayOfWeek={0}
          placeholder="Date of travel"
          value={formData.otherDate}
          minDate={formatDateToYMD(new Date())}
          onChange={(value) => {
            (updateFormField("otherDate", value),
              updateLocation(0, { date: value }));
          }}
          leftSection={
            <Calendar style={{ color: "#646464" }} width={10} height={10} />
          }
          styles={{
            table: {
              borderCollapse: "collapse !important",
              border: "0px none transparent !important",
              borderSpacing: "0 !important",
            },
            tbody: { border: "0 none transparent !important" },
            tr: { border: "0 none transparent !important" },
            td: {
              border: "0px none transparent !important",
              padding: "0 !important",
              outline: "none !important",
              boxShadow: "none !important",
            },
            th: {
              border: "0px none transparent !important",
              padding: "0 !important",
            },
            day: {
              border: "0px none transparent !important",
              outline: "none !important",
              boxShadow: "none !important",
            },
          }}
          popoverProps={{
            withinPortal: true,
            portalProps: { target: "#get-a-quote" },
            zIndex: 10000,
            position: "bottom-start",
            offset: 5,
            styles: {
              dropdown: {
                width: "300px",
                backgroundColor: "#ffffff",
                border: "1px solid #dee2e6",
                visibility: "visible",
                opacity: 1,
              },
            },
          }}
        />
        <AddressInput
          useCityPicker={true}
          index={0}
          updateLocation={updateLocation}
          updateFormField={updateFormField}
          locationType={"departure"}
          formData={formData}
        />
        <TimeDurationPicker
          formData={formData}
          onChange={(v) => updateFormField("duration", v)}
        />
        <Grid.Col span={12}>
          <>
            <style>{`
            .special-request-placeholder textarea::placeholder {
              font-size: 14px !important;
              font-style: normal !important;
              font-weight: 400 !important;
            }
          `}</style>
            <Textarea
              label="Additional details"
              labelProps={{
                style: { fontWeight: "600", marginBottom: "12px" },
              }}
              styles={{
                input: {
                  backgroundColor: "#F6F1F1",
                  borderRadius: "6px",
                  border: "0.5px solid black",
                  height: "105px",
                  padding: "16px 20px",
                  color: "#000",
                },
              }}
              value={formData.specialRequests}
              onChange={(e) =>
                updateFormField("specialRequests", e.currentTarget.value)
              }
              placeholder="Add any additional detail you want us to know to create a travel plan for you"
            />
          </>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
